import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import SettingsPageUI from './SettingsPageUI.js'

class SettingsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <SettingsPageUI
        context={this.props.context}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_settings',
      'c_user_settings',
      'c_account_settings',
      'c_account_users',
      'c_exit_account',
      'c_logout'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_settings', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SettingsPageSF
